import { useContext, useEffect, useState } from "react";

import "./overlay.scss";

import Link from "../link/link";

import { ThemeContext } from "../../App";

function Overlay(props) {
  const { overlayOpened, overlay, closeOverlay, contentVisible, overlayTheme } =
    useContext(ThemeContext);

  const [headerImage, setHeaderImage] = useState(null);

  function handleHeaderError(e) {
    console.log("error", overlay, e, headerImage);
    setHeaderImage(null);
  }

  useEffect(() => {
    if (overlayOpened) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [overlayOpened]);

  useEffect(() => {
    setHeaderImage(`/images/screens/${overlay.id}/desktop.png`);
  }, [overlay.id]);

  if (overlayOpened) {
    return (
      <aside
        className={`overlay${
          overlayTheme === "light" ? ` overlay--light` : ""
        }`}
      >
        <div className="overlay__background" onClick={() => closeOverlay()} />

        {!props.children ? (
          <div
            className={`overlay__content-wrapper${
              contentVisible ? " overlay__content-wrapper--visible" : ""
            }`}
            key={overlay.title}
          >
            {overlay.id && (
              <div className="overlay__image-wrapper">
                {headerImage ? (
                  <img
                    className="overlay__image"
                    src={headerImage}
                    alt={`${overlay.title} website desktop preview`}
                    loading="lazy"
                    onError={(e) => handleHeaderError(e)}
                  />
                ) : (
                  <div className="overlay__logo-wrapper">
                    <img
                      className="overlay__logo"
                      src={`/images/clients/${overlay.id}.png`}
                      alt={`${overlay.title} logo`}
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            )}
            <div className="overlay__content">
              <h3 className="overlay__headline">
                <Link
                  text={overlay.title}
                  href={overlay.href}
                  withIcon
                  dark
                  ariaLabel={`link zu ${overlay.title}`}
                />
              </h3>
              <p className="overlay__desciption">{overlay.description}</p>
              <div className="overlay__client">
                Agentur:{" "}
                <Link
                  text={overlay.client}
                  href={overlay.clientLink}
                  withIcon
                  dark
                  ariaLabel={`link zu ${overlay.client}`}
                />
              </div>
              <p className="overlay__techstack">
                Techstack:{" "}
                {overlay.techStack &&
                  overlay.techStack.map((item, index) => (
                    <Link
                      href={item.href}
                      className="overlay__techstack-item"
                      key={`techstack-${index}`}
                      ariaLabel={`link zu ${item.alt}`}
                    >
                      <img
                        className="overlay__techstack-item-logo"
                        src={item.image}
                        alt={item.alt}
                        loading="lazy"
                      />
                    </Link>
                  ))}
              </p>
            </div>
          </div>
        ) : (
          props.children
        )}

        <div className="overlay__burger" onClick={() => closeOverlay()} />
      </aside>
    );
  }

  return null;
}

export default Overlay;
